import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const ProfileMaleShape = ({
  width = 36,
  height = 36,
  fillColor = '#828282',
  style
}: BaseSVGType) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 36 32"
    enableBackground="new 0 0 36 32"
    xmlSpace="preserve"
    style={style}
  >
    <g>
      <path
        fill={fillColor}
        d="M0.5,31.983c0.268,0.067,0.542-0.088,0.612-0.354c1.03-3.843,5.216-4.839,7.718-5.435
		c0.627-0.149,1.122-0.267,1.444-0.406c2.85-1.237,3.779-3.227,4.057-4.679c0.034-0.175-0.029-0.355-0.165-0.473
		c-1.484-1.281-2.736-3.204-3.526-5.416c-0.022-0.063-0.057-0.121-0.103-0.171c-1.045-1.136-1.645-2.337-1.645-3.294
		c0-0.559,0.211-0.934,0.686-1.217c0.145-0.087,0.236-0.24,0.243-0.408C10.042,5.036,13.67,1.026,18.12,1
		c0.005,0,0.102,0.007,0.107,0.007c4.472,0.062,8.077,4.158,8.206,9.324c0.004,0.143,0.068,0.277,0.178,0.369
		c0.313,0.265,0.459,0.601,0.459,1.057c0,0.801-0.427,1.786-1.201,2.772c-0.037,0.047-0.065,0.101-0.084,0.158
		c-0.8,2.536-2.236,4.775-3.938,6.145c-0.144,0.116-0.212,0.302-0.178,0.483c0.278,1.451,1.207,3.44,4.057,4.679
		c0.337,0.146,0.86,0.26,1.523,0.403c2.477,0.536,6.622,1.435,7.639,5.232c0.06,0.223,0.262,0.37,0.482,0.37
		c0.043,0,0.086-0.006,0.13-0.017c0.267-0.072,0.425-0.346,0.354-0.613c-1.175-4.387-5.871-5.404-8.393-5.95
		c-0.585-0.127-1.09-0.236-1.336-0.344c-1.86-0.808-3.006-2.039-3.411-3.665c1.727-1.483,3.172-3.771,3.998-6.337
		c0.877-1.14,1.359-2.314,1.359-3.317c0-0.669-0.216-1.227-0.644-1.663C27.189,4.489,23.19,0.076,18.227,0.005l-0.149-0.002
		c-4.873,0.026-8.889,4.323-9.24,9.83c-0.626,0.46-0.944,1.105-0.944,1.924c0,1.183,0.669,2.598,1.84,3.896
		c0.809,2.223,2.063,4.176,3.556,5.543c-0.403,1.632-1.55,2.867-3.414,3.676c-0.241,0.105-0.721,0.22-1.277,0.352
		c-2.541,0.604-7.269,1.729-8.453,6.147C0.075,31.638,0.233,31.911,0.5,31.983z"
      />
    </g>
  </svg>
);

export default ProfileMaleShape;
